export default {"src":"/_next/static/image/public/images/ic_epharmacy_bg.0903e36a06994c77cefcb961f8b0fa2c.svg","height":70,"width":70};